import React, { memo } from 'react';
import { NodeBox } from '../../components/NodeBox';
import { ResourceName } from '../../components/ResourceName';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import styles from '../SuccessModifier/SuccessModifier.module.scss';

interface SplitterOutputProps {
  data: any;
  isPreview?: boolean;
}

/** Rule-managed branch: inspect it here, but edit or remove it through the splitter. */
export const SplitterOutput = memo((props: SplitterOutputProps) => {
  const { data } = props;

  return (
    <NodeBox data={data} className={styles.container}>
      <ResourceName {...props} hideActions>
        Splitter output
      </ResourceName>
      <div className={styles.modifierContainer}>
        <NodeBox.Title>{data?.name}</NodeBox.Title>
      </div>
      <NodeBox.Footer className={styles.transformFooter}>
        <div className={styles.bottomActions}>
          <ChipWithCopy tooltipTitle="Copy Splitter Output ID" toCopy={data?.id}>
            ID {data?.id}
          </ChipWithCopy>
        </div>
      </NodeBox.Footer>
    </NodeBox>
  );
});
